// extracted by mini-css-extract-plugin
export default {"input_item":"input_item-hNDbd","input_label":"input_label-ZIvJ0","input_content":"input_content-xn-dt"};